import { render } from "./SuggestionTag.vue?vue&type=template&id=f1b5e070"
import script from "./SuggestionTag.vue?vue&type=script&lang=js"
export * from "./SuggestionTag.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__